import { render, staticRenderFns } from "./permissionTree.vue?vue&type=template&id=4cb8f52c&scoped=true"
import script from "./permissionTree.vue?vue&type=script&lang=js"
export * from "./permissionTree.vue?vue&type=script&lang=js"
import style0 from "./permissionTree.vue?vue&type=style&index=0&id=4cb8f52c&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb8f52c",
  null
  
)

export default component.exports